import { render, staticRenderFns } from "./TeamTournaments.vue?vue&type=template&id=f78c753c&scoped=true"
import script from "./TeamTournaments.vue?vue&type=script&lang=js"
export * from "./TeamTournaments.vue?vue&type=script&lang=js"
import style0 from "./TeamTournaments.vue?vue&type=style&index=0&id=f78c753c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78c753c",
  null
  
)

export default component.exports